import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import { resetPassword } from '../services/api';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [form, setForm] = useState({ newPassword: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('This reset link is missing its token. Please request a new one.');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.newPassword !== form.confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    if (form.newPassword.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }

    setLoading(true);
    try {
      await resetPassword(token, form.newPassword);
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.response?.data?.message || 'This reset link is invalid or has expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <PageHeader eyebrow="Account Recovery" title="Reset Your Password" />
      <section className="section">
        <div className="container" style={{ maxWidth: 420 }}>
          <div className="card">
            {success ? (
              <div className="success-box">
                Your password has been reset. Redirecting you to login...
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                {error && <p className="error-text" style={{ marginBottom: 16 }}>{error}</p>}
                <div className="form-group">
                  <label>New Password</label>
                  <input
                    type="password"
                    required
                    value={form.newPassword}
                    onChange={(e) => setForm({ ...form, newPassword: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>Confirm New Password</label>
                  <input
                    type="password"
                    required
                    value={form.confirmPassword}
                    onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
                  />
                </div>
                <button type="submit" className="btn btn-gold btn-block" disabled={loading || !token}>
                  {loading ? 'Resetting...' : 'Reset Password'}
                </button>
              </form>
            )}
            <p style={{ textAlign: 'center', marginTop: 16, fontSize: '0.9rem' }}>
              <Link to="/forgot-password" style={{ color: 'var(--color-gold)', fontWeight: 600 }}>Request a new link</Link>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
